import { CommunicationChatApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';

export const useCommunicationChatApi = () => {
  const configuration = useApiConfiguration();
  return useMemo(
    () => new CommunicationChatApi(configuration),
    [configuration]
  );
};
